import { REMOVE_OBJ_KEY_FROM_ARRAY } from "../../../enums/Request/currentRequestControls.types";

export const removeObjectKeyInArray = (data) => {
    return {
        type: REMOVE_OBJ_KEY_FROM_ARRAY,
        payload: data,
    };
}
